import { IDENTITY_CONFIG, METADATA_OIDC } from "../utils/AuthConst";
import { UserManager, WebStorageStateStore, Log, User } from "oidc-client";
import { generateToken } from "./api/auth/auth-service";
import { analyticsService } from "./analytics.service";


const LOGIN_TRACKED_KEY = "login_tracked";

const getUserEmail = (user) =>
  user?.profile?.["http://schemas.xmlsoap.org/ws/2005/05/identity/claims/emailaddress"] ||
  user?.profile?.["http://schemas.xmlsoap.org/ws/2005/05/identity/claims/name"] ||
  user?.profile?.email ||
  user?.profile?.name ||
  user?.profile?.sub;


export const isAuthenticated = () => {
  const access_token = localStorage.getItem("access_token");
  return !!access_token;
};

export const setUserLocalStorage = (user) => {
  localStorage.setItem("access_token", user.access_token);
  localStorage.setItem("id_token", user.id_token);
  localStorage.setItem("user", JSON.stringify(user));
  localStorage.setItem("userId", user.profile.sub);
  localStorage.setItem("countryID", user.profile.countryID);
  localStorage.setItem("locale", user.profile.locale);
};

export default class AuthService {
  UserManager;
  accessToken;
  opaqueToken;

  constructor() {
    this.loadSearchParams();

    if (this.embedded && this.opaqueToken && !isAuthenticated()) {
      this.exchangeOpaqueToken(this.opaqueToken);
    }

    //Inicializar
    this.UserManager = new UserManager({
      ...IDENTITY_CONFIG,
      userStore: new WebStorageStateStore({ store: window.localStorage }),
      metadata: {
        ...METADATA_OIDC,
      },
    });

    

    //Logger
    Log.logger = console;
    Log.level = Log.DEBUG;

    this.UserManager.events.addUserLoaded((user) => {
      this.setUserToken(user);

      this.setUserInfo({
        accessToken: this.accessToken,
        idToken: user.id_token,
      });

      //alert('addUserLoaded');
      if (window.location.href.indexOf("signin-oidc") !== -1)
        this.navigateToScreen();
    });

    this.UserManager.events.addSilentRenewError((e) => {
      console.log("silent renew error", e.message);
    });

    this.UserManager.events.addAccessTokenExpired(() => {
      this.signinSilent();
    });
    

    this.UserManager.events.addUserSignedOut(_ => console.log('addUserSignedOut'));
    this.UserManager.events.addSilentRenewError(_ => console.log('addSilentRenewError'));
    this.UserManager.events.addUserUnloaded(_ => console.log('addUserUnloaded'));
  }

  signinRedirectCallback = () => {
    this.UserManager.signinRedirectCallback().then(() => {
      "";
    });
  };

  signinRedirect = () => {
    const urlParams = new URLSearchParams(window.location.search);
    localStorage.setItem(
      "redirectUri",
      window.location.pathname +
        (urlParams.toString() ? "?" + urlParams.toString() : ""),
    );
    !this.embedded && this.UserManager.signinRedirect({});
  };

  parseJwt = (token) => {
    const base64Url = token.split(".")[1];
    const base64 = base64Url.replace("-", "+").replace("_", "/");
    return JSON.parse(window.atob(base64));
  };

  setSessionInfo(authResult) {
    localStorage.setItem("access_token", authResult.accessToken);
    localStorage.setItem("id_token", authResult.idToken);
  }

  setUser = (data) => {
    localStorage.setItem("userId", data.sub);
  };

  setUserInfo = (authResult) => {
    const data = this.parseJwt(this.accessToken);
    this.setSessionInfo(authResult);
    this.setUser(data);
  };

  navigateToScreen = () => {
    const redirectUri = !!localStorage.getItem("redirectUri")
      ? localStorage.getItem("redirectUri")
      : "/app";
    const language = "/" + redirectUri.split("/")[1];
    window.location.replace(language + "/");
  };

  isAuthenticated = () => isAuthenticated();

  signinSilent = () => {
    this.UserManager.signinSilent()
      .then((user) => {
        console.log("signed in", user);
      })
      .catch((err) => {
        /*No se pudo hacer el silentRenew, hacer logout*/
        this.logout();
        console.log(err);
      });
  };

  signinSilentCallback = () => {
    this.UserManager.signinSilentCallback();
  };

  createSigninRequest = () => {
    return this.UserManager.createSigninRequest();
  };

  logout = () => {
    // GTM: Track logout event before clearing session
    try {
        const userStr = localStorage.getItem("user");

        if (userStr) {
          const user = JSON.parse(userStr);
          const email = getUserEmail(user);

          if (email) {
            analyticsService.logout(email);
          }
        }
    } catch (e) {
        console.error("Analytics logout tracking error:", e);
    }
    sessionStorage.removeItem(LOGIN_TRACKED_KEY);


    this.UserManager.signoutRedirect({
      id_token_hint: localStorage.getItem("id_token"),
    }).then(() => {
      localStorage.clear();
    });
    this.UserManager.clearStaleState();
  };

  signoutRedirectCallback = () => {
    this.UserManager.signoutRedirectCallback().then(() => {
      localStorage.clear();
      window.location.replace(IDENTITY_CONFIG.post_logout_redirect_uri);
    });
    this.UserManager.clearStaleState();
  };

  exchangeOpaqueToken = async (opaqueToken) => {
    generateToken(opaqueToken)
      .then(({ data }) => {
        const user = new User({
          id_token: data.access_token,
          access_token: data.access_token,
          token_type: "Bearer",
          scope: IDENTITY_CONFIG.scope,
          profile: this.parseJwt(data.access_token),
          expires_at: Math.floor(Date.now() / 1000) + data.expires_in,
        });

        this.setUserToken(user);

        this.setUserInfo({
          accessToken: this.accessToken,
          idToken: user.id_token,
        });

        window.location.reload();
      })
      .catch((error) => {
        console.error("Failed to obtain the token with opaque token", error);
      });
  };

  setUserToken = (user) => {
    this.accessToken = user.access_token;
    setUserLocalStorage(user);
  };

  loadSearchParams = () => {
    const urlParams = new URLSearchParams(window.location.search);
    this.embedded = urlParams.get("_embedded");
    this.opaqueToken = urlParams.get("_token");
  };
}
